import type { NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw } from 'vue-router';

import { RouteName } from '@/core/router/RouteName';
import { Scope } from '@/plugins/authentication/lib/UserPermissions';

const requiresScopes: Scope[] = [Scope.CLIENTS_ACCESS_ALL];

const routes: RouteRecordRaw[] = [
  // The following route (CONTRATS_BASE) is only useful to Nav.ts and the concerned configuration (MainNavConfig.ts),
  // because Nav.ts is curently unable to check routes with params
  // FIXME Refactor Nav.ts so that it can check route with params and delete CONTRATS_BASE route
  {
    name: RouteName.CONTRATS,
    path: '/contrats',
    component: () => import('@/domains/contrats/views/ContratsSingle/ContratsSingleRootPage.vue'),
    meta: {
      requiresAuth: true,
      requiresScopes,
    },
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext): void => {
      next({ name: RouteName.ERROR_NOT_FOUND });
    },
  },
  {
    name: RouteName.CONTRATS_SINGLE,
    path: '/contrats/:numeroContrat',
    component: () => import('@/domains/contrats/views/ContratsSingle/ContratsSingleRootPage.vue'),
    meta: {
      requiresAuth: true,
      requiresScopes,
    },
    props: true,
    children: [
      {
        name: RouteName.CONTRATS_SINGLE_ASSURES,
        path: 'assures',
        component: () => import('@/domains/contrats/views/ContratsSingle/ContratsSingleAssuresPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
      {
        name: RouteName.CONTRATS_SINGLE_COMMISSIONS,
        path: 'commissions',
        component: () => import('@/domains/contrats/views/ContratsSingle/ContratsSingleCommissionsPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
      {
        name: RouteName.CONTRATS_SINGLE_DOCUMENTS,
        path: 'documents',
        component: () => import('@/domains/contrats/views/ContratsSingle/ContratsSingleDocumentsPage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
      {
        name: RouteName.CONTRATS_SINGLE_SYNTHESE,
        path: '',
        component: () => import('@/domains/contrats/views/ContratsSingle/ContratsSingleSynthesePage.vue'),
        meta: {
          requiresAuth: true,
          requiresScopes,
        },
        props: true,
      },
    ],
  },
];

export default routes;
